import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { CheckBox, NumberBox, SelectBox, TextBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeMaterialMutation,
  useCreateMaterialMutation,
  useLazyGetMaterialDetailQuery,
} from 'bus/material/services/services';
import { MaterialItem } from 'bus/material/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: MaterialItem = {
  averageRate: 0,
  comment: '',
  isDeleted: false,
  isOverPayment: false,
  name: '',
  registerIncome: false,
  unitId: null,
  quantityTones: 0,
  comingNomenclaturePlace: null,
  minimalQuantity: null,
  quantityCubes: null,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<MaterialItem>(initialForm);

  const [getDetail] = useLazyGetMaterialDetailQuery();
  const [create, { isLoading: isLoadingCreate }] = useCreateMaterialMutation();
  const [change, { isLoading: isLoadingChange }] = useChangeMaterialMutation();
  const [comingNomenclaturePlaceItems, setComingNomenclaturePlaceItems] = useState([]);

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    if (id) {
      const result = await getDetail({ id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const unitDataSource: any = useMemo(() => {
    return $createDataSource('/v1/unit', 'id');
  }, []);

  const comingNomenclaturePlaceSource: any = useCallback(async () => {
    const data = await $createDataSource('/v1/Material/comingNomenclaturePlace', 'id').load();
    setComingNomenclaturePlaceItems(data);
  }, []);

  useEffect(() => {
    comingNomenclaturePlaceSource();
  }, [comingNomenclaturePlaceSource]);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await change({ ...form, id });
      } else {
        await create({ ...form });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Материал"
        width={500}
        minHeight={480}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Наименование" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Наименование"
                            mode="text"
                            value={form.name}
                            onValueChange={(e: any) => {
                              setForm((prev) => ({ ...prev, name: e }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Наименование" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>
                        <AppFiledBox label="Ед. изм." labelTop>
                          <div className="d-flex align-center">
                            <SelectBox
                              stylingMode="underlined"
                              style={{ width: '100%' }}
                              dataSource={unitDataSource}
                              displayExpr="name"
                              valueExpr="id"
                              value={form.unitId}
                              onValueChange={(e) => {
                                setForm((prev) => ({ ...prev, unitId: e }));
                              }}
                            >
                              <DropDownOptions title="Выберите Ед. изм." closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите Ед. изм." />
                              </Validator>
                            </SelectBox>
                          </div>
                        </AppFiledBox>

                        <AppFiledBox label="" labelTop>
                          <CheckBox
                            value={form.registerIncome}
                            text="Учет прихода"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, registerIncome: !!e }))}
                          />
                        </AppFiledBox>

                        {form.registerIncome && (
                          <>
                            <AppFiledBox label="Объём в кубе" labelTop>
                              <NumberBox
                                stylingMode="underlined"
                                placeholder="Введите кубах"
                                mode="number"
                                format="###0.###"
                                value={form.quantityCubes ?? 0}
                                onValueChanged={(e) => {
                                  setForm((prev) => ({ ...prev, quantityCubes: e.value || null }));
                                }}
                              >
                                <Validator>
                                  <RequiredRule message="Заполните поле кубах" />
                                </Validator>
                              </NumberBox>
                            </AppFiledBox>

                            <AppFiledBox label="Масса в тонне" labelTop>
                              <NumberBox
                                stylingMode="underlined"
                                placeholder="Введите объём"
                                mode="number"
                                format="###0.###"
                                value={form.quantityTones}
                                onValueChanged={(e) => {
                                  setForm((prev) => ({ ...prev, quantityTones: e.value }));
                                }}
                              >
                                <Validator>
                                  <RequiredRule message="Заполните поле объём" />
                                </Validator>
                              </NumberBox>
                            </AppFiledBox>

                            <AppFiledBox label="Место доставки" labelTop>
                              <div className="d-flex align-center">
                                <SelectBox
                                  stylingMode="underlined"
                                  style={{ width: '100%' }}
                                  items={comingNomenclaturePlaceItems}
                                  displayExpr="name"
                                  valueExpr="id"
                                  value={form.comingNomenclaturePlace}
                                  onValueChange={(e) => {
                                    setForm((prev) => ({ ...prev, comingNomenclaturePlace: e, minimalQuantity: null }));
                                  }}
                                >
                                  <DropDownOptions
                                    title="Выберите Место доставки."
                                    closeOnOutsideClick={true}
                                    showTitle={false}
                                  />
                                  <Validator>
                                    <RequiredRule message="Выберите Место доставки" />
                                  </Validator>
                                </SelectBox>
                              </div>
                            </AppFiledBox>

                            {form.comingNomenclaturePlace === 0 && (
                              <AppFiledBox label="Минимальный остаток" labelTop>
                                <NumberBox
                                  stylingMode="underlined"
                                  placeholder="Введите остаток"
                                  mode="number"
                                  format="###0.###"
                                  value={form.minimalQuantity ?? 0}
                                  onValueChanged={(e) => {
                                    setForm((prev) => ({ ...prev, minimalQuantity: e.value }));
                                  }}
                                >
                                  <Validator>
                                    <RequiredRule message="Заполните поле Минимальный остаток" />
                                  </Validator>
                                </NumberBox>
                              </AppFiledBox>
                            )}
                          </>
                        )}

                        <AppFiledBox label="" labelTop>
                          <CheckBox
                            value={form.isOverPayment}
                            text="Переплата за доставку"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, isOverPayment: !!e }))}
                          />
                        </AppFiledBox>
                        {form.isOverPayment && (
                          <AppFiledBox label="Коэффициент переплаты" labelTop>
                            <NumberBox
                              stylingMode="underlined"
                              placeholder="0"
                              value={form.averageRate}
                              onValueChanged={(e) => {
                                setForm((prev) => ({ ...prev, averageRate: e.value }));
                              }}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле Коэффициент переплаты" />
                              </Validator>
                            </NumberBox>
                          </AppFiledBox>
                        )}
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
